/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Agents_TitleInputs */

const vi_print_admin_agents_title = /** @type {(inputs: Print_Admin_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent in tại điểm bán`)
};

/**

* @param {Print_Admin_Agents_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_agents_title = /** @type {((inputs?: Print_Admin_Agents_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Agents_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_agents_title(inputs)
});